import { useState } from "react";
import "./ShippingUI.css";
import { ShippingRate } from "../../Interfaces/ShippingInfo";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";
import { set } from "date-fns/set";
import BoxDimensions from "../BoxDimensions";
import BuyShippingLabel from "./BuyShippingLabel";

interface ShippingUIProps {
  shipToName: string;
  shipToAddress1: string;
  shipToAddress2: string;
  shipToCity: string;
  shipToState: string;
  shipToZip: string;
  shipToCountry: string;
}

const ShippingUI: React.FC<ShippingUIProps> = ({
  shipToName,
  shipToAddress1,
  shipToAddress2,
  shipToCity,
  shipToState,
  shipToZip,
  shipToCountry,
}) => {
  const [packageDimensions, setPackageDimensions] = useState({
    weight: 0,
    length: 0,
    width: 0,
    height: 0,
  });
  const [packageDimensionError, setPackageDimensionError] = useState("");
  const [shippingRates, setShippingRates] = useState<ShippingRate[]>([]);
  const [selectedRateId, setSelectedRateId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const retrieveShippingRates = async () => {
    try {
      if (packageDimensionError) return;
      setIsLoading(true);
      const bodyToSend = {
        package_length: packageDimensions.length,
        package_width: packageDimensions.width,
        package_height: packageDimensions.height,
        package_weight: packageDimensions.weight,
        address_to: {
          name: shipToName,
          street1: shipToAddress1,
          street2: shipToAddress2,
          city: shipToCity,
          state: shipToState,
          zip: shipToZip,
          country: shipToCountry,
        },
      };
      const response = await fetchWithAuth(
        `${config.API_BASE_URL}orders/fetch-shipping-rates/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyToSend),
        }
      );

      if (!response.ok) {
        setShippingRates([]);
        return;
      }
      setShippingRates(await response.json());
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="shipping-ui-container">
      <div className="shipping-ui-left">
        <BoxDimensions
          packageDimensions={packageDimensions}
          setPackageDimensions={setPackageDimensions}
          packageDimensionError={packageDimensionError}
          setPackageDimensionError={setPackageDimensionError}
        />
        <button
          className="shipping-ui-button"
          onClick={retrieveShippingRates}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Get Shipping Rates"}
        </button>
      </div>

      <div className="shipping-ui-right">
        <h3>Available Shipping Rates</h3>
        <BuyShippingLabel
          selectedRateId={selectedRateId}
          isLoading={isLoading}
          shippingRates={shippingRates}
          setIsLoading={setIsLoading}
          setSelectedRateId={setSelectedRateId}
        />
      </div>
    </div>
  );
};

export default ShippingUI;
